import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { Location } from '@angular/common';

@Component({
  selector: 'error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {
  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb

  constructor(
    private location: Location
  ) { }

  ngOnInit() {
    
  }

  navigateToPrevious() {
    this.location.back();
  }

}
